import Loader from "modus/components/misc/Loader";
import React from "react";
import { useSelector } from "react-redux";
export const AuthorizationLoader = () => {
  const { permissions } = useSelector((state: any) => ({
    permissions: state.userManager.resources,
  }));

  return <>{(!permissions || Object.keys(permissions).length === 0 ) && <Loader showBackDrop />}</>;
};
